/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
import React from 'react';

const RulesMiddleware = ({ children, middlewareProps, renderRules = [], propRules = {} }) => {

  const { operator = 'AND' } = middlewareProps;

  const undefinedCheck = (element) => element !== undefined;

  const hasAllRules = renderRules.every(undefinedCheck);

  let shouldRender = true;

  if (renderRules.length && hasAllRules) {
    if (operator === 'AND') {
      shouldRender = renderRules.every(Boolean);
    } else if (operator === 'OR') {
      shouldRender = renderRules.some(Boolean);
    }
  }

  if (!shouldRender) {
    return null;
  }

  return children({ props: { ...propRules } });
};

RulesMiddleware.propTypes = {};

RulesMiddleware.displayName = 'RulesMiddleware';

RulesMiddleware.dataModel = {};

export { RulesMiddleware };
